// From https://stackoverflow.com/a/25490531
export default function getCookieByName(name: string): string {
  return document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`)?.pop() || "";
}
